import { ItemSort, SortValueMapper } from './sort-popover.types';

export const makeSortComparator =
  <ItemType extends Record<string, any>, FieldType extends string>(
    sorting: Array<ItemSort<FieldType>> | ItemSort<FieldType>,
    valueMapper: SortValueMapper<ItemType, FieldType>,
  ) =>
  (a: ItemType, b: ItemType): number => {
    const sorts = Array.isArray(sorting) ? sorting : [sorting];
    for (const sort of sorts) {
      // get the actual values to compare
      // values could be arrays or objects (e.g. dates) so we transform them for strict comparison
      const aVal = valueMapper(sort.field, a);
      const bVal = valueMapper(sort.field, b);

      // IF values are equal THEN proceed to next sort
      if (aVal === bVal) {
        continue;
      }

      // IF value is null THEN sort last
      if (aVal === null) {
        return 1;
      }
      if (bVal === null) {
        return -1;
      }

      return sort.direction === 'ASC' ? (aVal > bVal ? 1 : -1) : aVal > bVal ? -1 : 1;
    }

    // IF all sorts are equal THEN return 0
    return 0;
  };
